import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "reliability-observability-foundation",
    section: "portfolio",
    header: "Embedded Hardware",
    title: "O'Neill Modular Systems",
    description: "A credible alternative to the cloud, built for mid-sized enterprise infrastructure.",
    tags: [
        articleTag("openstack-icon-svgrepo-com.svg"),
        articleTag("kubernetes.svg"),
        articleTag("grafana.svg"),
        articleTag("prometheus-svgrepo-com.svg"),
        articleTag("ubuntu-svgrepo-com.svg"),
    ],
    url: "/articles/reliability-observability-foundation",
};

export default META;
